import { ProductType } from '@/helpers/enums'

export default class {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static isThirdPartyApp(service: any): boolean {
    return service && service.type__c == ProductType.ThirdPartySolution
  }

  static isThirdPartyType(productType: string): boolean {
    return productType === ProductType.ThirdPartySolution
  }
}
